import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M133.8 16.6c15.3 4.6 29.1 12.6 40.2 23.2l16 15.3V190h-56.2V16.6zm-11.3 146V190H10v-20.4l17.5-2.1c13.2-1.6 26.4-2.8 39.6-3.6 9.9-.6 19.9-1 29.8-1.2l10-.1h15.6zm-8.7-49.7 8.7.2v36.1h-3.4c-33.9 0-67.7 3.3-100.8 9.9l-8.3 1.7v-32c15.5-6.7 33.1-11.2 52.7-13.4 17-2 34-2.8 51.1-2.5zm3-52.3 5.7.4v37.8c-20.7-1.4-41.6-.3-62 3.2-19.7 3.3-35.6 8.5-47.8 15.5l-2.7 1.7V88c16.4-11.3 33.9-19 52.7-23.2 17-3.8 35.1-5.2 54.1-4.2zm-1.3-49.1 7 1.2v35.9c-20.7-2.8-41.9-1.6-62 3.7-19.3 5-35.3 13-47.9 24.2L10 79V45.2c14.5-10.5 30.2-19.3 47-26.5l1.9-.8c17.7-7.5 37.5-9.7 56.6-6.4z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}